interface CalendarIconProps {
  className?: string;
}

export function CalendarIcon({ className }: CalendarIconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_calendar)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 1C6 0.447715 5.55229 0 5 0C4.44772 0 4 0.447715 4 1V2H3C2.20435 2 1.44129 2.31607 0.87868 2.87868C0.316071 3.44129 0 4.20435 0 5V8V17C0 17.7957 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H17C17.7957 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7957 20 17V8V5C20 4.20435 19.6839 3.44129 19.1213 2.87868C18.5587 2.31607 17.7957 2 17 2H16V1C16 0.447715 15.5523 0 15 0C14.4477 0 14 0.447715 14 1V2H6V1ZM18 7V5C18 4.73479 17.8946 4.48043 17.7071 4.2929C17.5196 4.10536 17.2652 4 17 4H15.001H15H14.999H5.00099H4.99901H3C2.73478 4 2.48043 4.10536 2.29289 4.2929C2.10536 4.48043 2 4.73479 2 5V7H18ZM2 9H18V17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8947 17.2652 18 17 18H3C2.73478 18 2.48043 17.8947 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V9Z"
          fill="#A8B4BD"
        />
      </g>
      <defs>
        <clipPath id="clip0_calendar">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
